import { lazy } from 'react';
import { retry } from '../../config/utils';

const LenderType = lazy(() =>  retry(()=>import(/* webpackChunkName: "LenderType" */ "./index")));

export default LenderType;